var _style, _g, _g2, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSpoonfork(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 400 135.7",
    style: {
      enableBackground: "new 0 0 400 135.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M382.1,32.9c-1.3-3.8-3.3-7.4-5.7-10.7c-10.3-14.1-31.8-18.6-50.7-9.6c-15.9,7.6-20.7,8.7-25.2,9.6 c-6.6,1.4-9.5,1.8-22.8,2.4c-6.2,0.3-15.1,0.2-16.6,0.1c-60.5-3-120.8-5.6-180.9-7.6c-23.1-1.1-26.1,25.1-5.5,26.8 c104-0.3,179.1,6.6,196,13.5c12.6,5.2,20.9,11.9,20.9,11.9c10,8,9.6,12,17.1,17.4c2.4,1.7,18.5,12.8,39.2,6.4 c2.3-0.7,22.7-8,31.1-26.2C385,53.9,385.5,42.6,382.1,32.9z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9914 -0.1308 0.1308 0.9914 -3.2565 10.5245)",
    className: "st0",
    cx: 78.5,
    cy: 30,
    rx: 9.1,
    ry: 5.9
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M54.2,81.6c8.9,1.1,16.2,2,16.2,2c6.2,1.1,5,10.4-0.1,10.1l-48.7-4.8c-6.4,0.4-5.4,8.5,0.5,9.6l50.1,5 c6.6,0.9,5.4,11.3,1.1,11.3l-50.5-5c-5.7,0.6-5.4,10,1.1,10.9l52.3,4.7c8.1-1.5,15.2-4.1,18.4-6.7c3.9-3.2,6.5-4.7,10.9-9.9 c2.2-2.5,4.2-4.6,9.1-4.9c0,0,173.2,17.2,180.7,17.9c0.5,0,0.9,0.1,0.9,0.1c20.6,1.3,18.2-24.6-3.7-25.5L113.4,80.6 c-6-1.3-8.5-4.2-13.3-9.2c-4.7-4.9-9.2-9.1-12.4-11.6c-4.5-3.7-8.3-5.8-17.1-7.5l-46.9-4.7c-9.9-1.2-12.2,8.9-1.1,10.9l47.9,4.8 c5.9,1.2,5.8,12.4-0.7,11l-47.5-5.4c-7.8-0.2-6.2,7.7-0.7,8.7C21.7,77.6,40,79.8,54.2,81.6z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.1788 -0.9839 0.9839 0.1788 134.0302 379.4289)",
    className: "st0",
    cx: 294.3,
    cy: 109.4,
    rx: 5.8,
    ry: 7.7
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M348.5,21.3c23.7,4.7,21,24.5,20.3,31.7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M88.9,71.6c6.7,6,9.9,17.1,27.4,18.1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpoonfork);
export default __webpack_public_path__ + "static/media/spoonfork.e16ee8db9a59ce444f91485aef83785f.svg";
export { ForwardRef as ReactComponent };